// extracted by mini-css-extract-plugin
export default {"selectOccurrence":"style_selectOccurrence__2+Kzu"};